import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ticket-view-product',
  templateUrl: './ticket-view-product.component.html',
  styleUrls: ['./ticket-view-product.component.scss']
})
export class TicketViewProductComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { }

  ngOnInit(): void {
  }

}
